export default {
  wxApi: '/api/wechat/config', /* 获取微信授权接口 */
  postRentApi: 'api/customersFindShop/insert', /* 租客 */
  postLookApi: '/api/applicationForLease/insert', /* 房东 */
  countNumApi: '/api/count/queryCountNumber' /* 数据统计 */
}



// WEBPACK FOOTER //
// ./src/common/js/api.js